import * as Hooks from 'preact/hooks';
import * as ModaSofaTemplateStore from '../../store/modaSofaTemplates';
import * as Selectors from '../../store/selectors';
import * as Logging from '../../store/actions/logging';
import { useDispatch, useSelector } from './redux';

export const useGetSofaTemplates = () => {
    const dispatch = useDispatch();
    const tenantIdentifier = useSelector(Selectors.Core.tenantIdentifier);

    Hooks.useEffect(
        () => {
            if (!tenantIdentifier) return;
            const templatesSetter = async () => {
                let templates;
                switch (tenantIdentifier) {
                    case 'moda':
                        templates = (await import('../../hardcodedProductData/moda/sofaTemplates'))
                            .sofaTemplates;
                        break;
                    case 'article':
                        templates = (
                            await import('../../hardcodedProductData/article/sofaTemplates')
                        ).sofaTemplates;
                        break;
                    default:
                        dispatch(
                            Logging.logWarning('no sofa templates for tenant found', {
                                tenantIdentifier,
                            }),
                        );
                        templates = {};
                }
                // seed the layouts store
                dispatch(ModaSofaTemplateStore.setSofaTemplates({ templates }));
            };

            templatesSetter();
        },
        //only run hook when product data changes
        [tenantIdentifier],
    );
};
